<template>
  <div id="operation-view">
    <v-layout row wrap my-4>
      <v-flex offset-xs2 xs8>
        <v-list dark>
          <v-list-group append-icon="expand_more" no-action :value="true">
            <template v-slot:activator>
              <v-list-tile data-testid="sidebar-new-transaction-drop-down">
                <v-list-tile-content>
                  <v-list-tile-title>{{i18n('Transações')}}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
            <v-list-tile @click="selectOperation('receive')" active-class="list-active" v-if="$root.userAllowedTo('transactions-create-receive')" data-testid="sidebar-new-transaction-receive-menu">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{i18n('Cobrar do cliente')}}
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn icon ripple>
                  <v-icon color="grey lighten-1">navigate_next</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
            <v-list-tile @click="selectOperation('pay')" active-class="list-active" v-if="$root.userAllowedTo('transactions-create-pay')" data-testid="sidebar-new-transaction-pay-menu">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{i18n('Pagar o cliente')}}
                </v-list-tile-title>
                <span class="caption item-description"></span>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn icon ripple>
                  <v-icon color="grey lighten-1">navigate_next</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
            <v-list-tile @click="selectOperation('deposit')" active-class="list-active" v-if="$root.userAllowedTo('transactions-create-deposit')" data-testid="sidebar-new-transaction-deposit-menu">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{i18n('Depósito em conta interna')}}
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn icon ripple>
                  <v-icon color="grey lighten-1">navigate_next</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
            <v-list-tile
              @click="selectOperation('withdrawal_internal')" active-class="list-active" v-if="$root.userAllowedTo('transactions-create-withdrawal_internal')" data-testid="sidebar-new-transaction-withdrawal-internal-menu">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{i18n('Retirada de conta interna')}}
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn icon ripple>
                  <v-icon color="grey lighten-1">navigate_next</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
            <v-list-tile
              @click="selectOperation('exchange_internal')" active-class="list-active" v-if="$root.userAllowedTo('transactions-create-exchange_internal')" data-testid="sidebar-new-transaction-exchange-internal-menu">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{i18n('Conversão entre contas internas')}}
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn icon ripple>
                  <v-icon color="grey lighten-1">navigate_next</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
            <v-list-tile
              @click="selectOperation('fee_payoff')" active-class="list-active" v-if="$root.userAllowedTo('transactions-create-withdrawal_internal')" data-testid="sidebar-new-transaction-fee-payoff-menu">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{i18n('Pagamento de taxas')}}
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn icon ripple>
                  <v-icon color="grey lighten-1">navigate_next</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list-group>
        </v-list>
      </v-flex>
    </v-layout>
    <div class="buttons-container">
      <v-btn flat dark @click="$emit('handle-event', {cancel: true})" class="cancel-btn" style="flex: 1" data-testid="sidebar-new-transaction-cancel-button">
        {{i18n('Cancelar')}}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OperationView',
  data() {
    return {
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    selectOperation(operation) {
      this.$emit('handle-event', { selected_operation: operation })
    }
  },
  mounted() {
    this.$root.$on('userUpdated', (user) => {
      this.$forceUpdate()
    })
  }
}
</script>

<style>
#operation-view .v-list {
  background: #0C2E4A;
  border-radius: 4px 4px 0 0;
  padding: 0 0;
}
#operation-view .v-list__tile {
  background: #0C2E4A;
}
#operation-view .v-list__tile:not(.list-active):hover {
  background: rgb(14, 51, 82);
}
#operation-view .list-active {
  background: rgb(28, 75, 114);
}
#operation-view .v-list__group::before,
#operation-view .v-list__group::after {
  background: none;
}
#operation-view .v-list__group .v-list__group__items .v-list__tile {
  padding-left: 12px;
  background: #213F57;
}
#operation-view .v-list__group .v-list__group__items .v-list__tile:not(.list-active):hover {
  background: #264864;
}
#operation-view .v-list__group .v-list__group__items .v-list__tile.list-active {
  background: #38566E;
}

#operation-view .v-list__group .v-list__group__items .v-list__tile__title {
  color: #BCC1D1;
  text-transform: uppercase;
  font-size: 14px;
}
#operation-view .item-description {
  font-style: italic;
  color: #BCC1D1;
}
</style>



// WEBPACK FOOTER //
// src/components/NewTransaction/OperationView.vue